import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { TmsWebBaseImportService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class ImportProductWarehouseStockLevelService extends TmsWebBaseImportService {
  constructor() {
    super('ImportProductWarehouseStockLevel', 'Stock Levels');
  }

  // Apply the previewed rows.
  confirmImport(rows: any[]): Observable<any> {
    return this.httpService.post(`${this.apiUrl}/ImportConfirmed`, rows);
  }

  // Export what is set today, so it can be edited in a spreadsheet and imported back.
  exportStockLevels(): Observable<any> {
    return this.httpService
      .getForText(`${this.apiUrl}/ExportTemplateAndData`)
      .pipe(tap((data: string) => this.downloadExportFile(data, 'StockLevels')));
  }
}
